export const colorTokens = {
  ink: '#28445f',
  inkMuted: '#6f88a1',
  canvas: '#f7fbff',
  surface: '#ffffff',
  surfaceMuted: '#eef6fd',
  line: '#dbe8f4',
  primary: '#8fc3ea',
  primaryStrong: '#dceefe',
  secondary: '#bddcf4',
  secondarySoft: '#edf7ff',
  success: '#8eb9a2',
  warning: '#d7c8ab',
  danger: '#ddb8b8',
  info: '#b7d4ef',
};

export const shadowTokens = {
  soft: '0 14px 30px rgba(143, 195, 234, 0.14)',
  raised: '0 12px 24px rgba(143, 195, 234, 0.18)',
};

export const radiusTokens = {
  card: 24,
  pill: 999,
};
